var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeIndex"},[_c('homeBanner'),_c('homeDownload'),_c('div',{staticClass:"homeContent",style:({
      background:
        _vm.$route.name == 'indexs' || _vm.$route.name == 'homes'
          ? '#f5f5f5'
          : '#FFFFFF',
    })},[_c('div',{staticClass:"homeContent_center"},[_c('homeContent'),_c('gameNewRecom'),_c('listGmaeCom')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }